import {
  environment
} from './environment'
export let domain = environment.domain
export let domainFirebase = environment.domainFirebase
export let serverName = environment.serverName
import axios from 'axios'

export const headers = {
  "server-name": serverName,
  "Content-Type": "application/json",
  Accept: "application/json",
}
export function headersWithToken() {
  return ({
    ...headers,
    "x-session-token": localStorage.getItem("x-session-token") !== null && localStorage.getItem("x-session-token") !== '' ? localStorage.getItem("x-session-token") : '',
    "Access-Control-Allow-Origin": "*",
    "Access-Control-Allow-Headers": "Origin, X-Requested-With, Content-Type, Accept"
  })
}
export function headersWithTokenForImage() {
  return {
    "server-name": serverName,
    "x-session-token": localStorage.getItem("x-session-token") !== null && localStorage.getItem("x-session-token") !== '' ? localStorage.getItem("x-session-token") : '',
    'Content-Type': 'multipart/form-data'
  }
}
export const uploadImgEndpoint = `${domain}/upload/image/course`
export const get = (path, params) => {
  return axios.get(`${domain}${path}`, {
    headers: headersWithToken(),
    params: params
  })
    .then(response => {
      return response.data.result
    })
    .catch(e => {
      if (e.response.status === 401) {
        // console.log(window.location.protocol+"//" + window.location.hostname+`${window.location.port!==""? ":"+window.location.port : ''}` + "/login")
        window.location.href = window.location.protocol + "//" + window.location.hostname + `${window.location.port !== "" ? ":" + window.location.port : ''}` + "/login"
      }
      let responseResult = {
        code: e.response.status,
        status: e.response.data.status,
        message: e.response.data.message,
      }
      return responseResult

    });

}
export const firebaseGet = (path, params) => {
  return axios.get(`${domainFirebase}${path}`, {
    headers: headersWithToken(),
    params: params
  })
    .then(response => {
      console.log("🚀 ~ file: configApi.js ~ line 57 ~ firebaseGet ~ response", response)
      return response.data.result
    })
    .catch(e => {
      if (e.response.status === 401) {
        // console.log(window.location.protocol+"//" + window.location.hostname+`${window.location.port!==""? ":"+window.location.port : ''}` + "/login")
        window.location.href = window.location.protocol + "//" + window.location.hostname + `${window.location.port !== "" ? ":" + window.location.port : ''}` + "/login"
      }
      let responseResult = {
        code: e.response.status,
        status: e.response.data.status,
        message: e.response.data.message,
      }
      return responseResult

    });
}
export const post = (path, body) => {
  return axios.post(`${domain}${path}`,
    JSON.stringify(body), {
    headers: headersWithToken(),
  }
  )
    .then(response => {
      return response.data.result
    })
    .catch(e => {
      if (e.response.status === 401) {
        window.location.href = window.location.protocol + "//" + window.location.hostname + `${window.location.port !== "" ? ":" + window.location.port : ''}` + "/login"
      }
      let responseResult = {
        code: e.response.status,
        status: e.response.data.status,
        message: e.response.data.message,
      }
      return responseResult
    })
}

export const firebasePost = (path, body) => {
  return axios.post(`${domainFirebase}${path}`,
    JSON.stringify(body), {
    headers: headersWithToken(),
  }
  )
    .then(response => {
      return response.data.result
    })
    .catch(e => {
      if (e.response.status === 401) {
        window.location.href = window.location.protocol + "//" + window.location.hostname + `${window.location.port !== "" ? ":" + window.location.port : ''}` + "/login"
      }
      let responseResult = {
        code: e.response.status,
        status: e.response.data.status,
        message: e.response.data.message,
      }
      return responseResult
    })
}
export const postByOtherDomain = (path, body) => {
  return axios.post(`${path}`,
    JSON.stringify(body),
  )
    .then(response => {
      return response.data
    })
    .catch(e => {
      if (e.response.status === 401) {
        window.location.href = window.location.protocol + "//" + window.location.hostname + `${window.location.port !== "" ? ":" + window.location.port : ''}` + "/login"
      }
      let responseResult = {
        code: e.response.status,
        status: e.response.data.status,
        message: e.response.data.message,
      }
      return responseResult
    })
}
export const postWithFormData = (path, file) => {
  let data = new FormData();
  data.append('fileupload', file)
  return axios.post(`${domain}${path}`,
    data, {
    headers: headersWithTokenForImage(),
  }
  )
    .then(response => {
      return response.data.result
    })
    .catch(e => {
      if (e.response.status === 401) {
        window.location.href = window.location.protocol + "//" + window.location.hostname + `${window.location.port !== "" ? ":" + window.location.port : ''}` + "/login"
      }
      let responseResult = {
        code: e.response.status,
        status: e.response.data.status,
        message: e.response.data.message,
      }
      return responseResult
    })
}
export const postWithNoToken = (path, body) => {
  return axios.post(`${domain}${path}`,
    JSON.stringify(body), {
    headers: headers,
  }
  )
    .then(response => {
      return response.data.result
    })
    .catch(e => {
      let responseResult = {
        code: e.response.status,
        status: e.response.data.status,
        message: e.response.data.message,
      }
      return responseResult
    })
}
export const postLogin = (path, body) => {
  return axios.post(`${domain}${path}`,
    JSON.stringify(body), {
    headers,
  }
  )
    .then(async response => {
      return await response
    })
    .catch(e => {
      let responseResult = {
        code: e.response.status,
        status: e.response.data.status,
        message: e.response.data.message,
      }
      return responseResult
    })
}

export const firebasePut = (path, body) => {
  return axios.put(`${domainFirebase}${path}`,
    JSON.stringify(body), {
    headers: headersWithToken(),
  }
  )
    .then(response => {
      return response.data.result
    })
    .catch(e => {
      if (e.response.status === 401) {
        window.location.href = window.location.protocol + "//" + window.location.hostname + `${window.location.port !== "" ? ":" + window.location.port : ''}` + "/login"
      }
      let responseResult = {
        code: e.response.status,
        status: e.response.data.status,
        message: e.response.data.message,
      }
      return responseResult
    })
}

export const put = (path, body) => {
  return axios.put(`${domain}${path}`,
    JSON.stringify(body), {
    headers: headersWithToken(),
  }
  )
    .then(response => {
      return response.data.result
    })
    .catch(e => {
      if (e.response.status === 401) {
        window.location.href = window.location.protocol + "//" + window.location.hostname + `${window.location.port !== "" ? ":" + window.location.port : ''}` + "/login"
      }
      let responseResult = {
        code: e.response.status,
        status: e.response.data.status,
        message: e.response.data.message,
      }
      return responseResult
    })
}
export const putWithNoToken = (path, body) => {
  return axios.put(`${domain}${path}`,
    JSON.stringify(body), {
    headers: headers,
  }
  )
    .then(response => {
      return response.data.result
    })
    .catch(e => {
      let responseResult = {
        code: e.response.status,
        status: e.response.data.status,
        message: e.response.data.message,
      }
      return responseResult
    })
}
export const delWithBody = (path, body) => {
  return axios.del(`${domain}${path}`,
    JSON.stringify(body), {
    headers: headersWithToken(),
  }
  )
    .then(response => {
      return response.data.result
    })
    .catch(e => {
      let responseResult = {
        code: e.response.status,
        status: e.response.data.status,
        message: e.response.data.message,
      }
      return responseResult
    })
}
export const del = (path, params) => {
  return axios.delete(`${domain}${path}`,
    {
      headers: headersWithToken(),
      params: params
    }
  )
    .then(response => {
      return response.data.result
    })
    .catch(e => {
      if (e.response.status === 401) {
        window.location.href = window.location.protocol + "//" + window.location.hostname + `${window.location.port !== "" ? ":" + window.location.port : ''}` + "/login"
      }
      let responseResult = {
        code: e.response.status,
        status: e.response.data.status,
        message: e.response.data.message,
      }
      return responseResult
    })
}

export const firebaseDel = (path, params) => {
  return axios.delete(`${domainFirebase}${path}`,
    {
      headers: headersWithToken(),
      params: params
    }
  )
    .then(response => {
      return response.data.result
    })
    .catch(e => {
      if (e.response.status === 401) {
        window.location.href = window.location.protocol + "//" + window.location.hostname + `${window.location.port !== "" ? ":" + window.location.port : ''}` + "/login"
      }
      let responseResult = {
        code: e.response.status,
        status: e.response.data.status,
        message: e.response.data.message,
      }
      return responseResult
    })
}

export const postWithMixFormData = (path, data) => {
  return axios.post(`${domain}${path}`,
    data, {
    headers: headersWithTokenForImage(),
  }
  )
    .then(response => {
      return response.data.result
    })
    .catch(e => {
      if (e.response.status === 401) {
        window.location.href = window.location.protocol + "//" + window.location.hostname + `${window.location.port !== "" ? ":" + window.location.port : ''}` + "/login"
      }
      let responseResult = {
        code: e.response.status,
        status: e.response.data.status,
        message: e.response.data.message,
      }
      return responseResult
    })
}